module.exports = __webpack_public_path__ + "assets/719ea9228e3cf6c0ae3b41e07097357b.png";